exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.simple-date{\n}\n.simple-date-item{\n}\n\n#simpleDate .mat-form-field{\n  width: 120px;\n  padding: 0 10px;\n}\n\n@media (max-width: 767px) {\n  .simple-date {\n    display: flex;\n    flex-flow: column;\n    flex-direction: column-reverse;\n    width: 100%;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/simple-date-picker/simple-date-picker.component.css
// module id = 948
// module chunks = 3